import type { GenomicFeatureTypeEnum } from "./openapi";
import { TrackEnum } from "./openapi";

export const GROUP_HEADER_HEIGHT = 20;
export const COORDINATE_TICK_HEIGHT = 4;
export const MIN_BASE_PER_PIXEL = 1 / 100;
export const MAX_BASE_PER_PIXEL = 10 ** 9; // It displays approx. 3 bilions of bases in a single screen.
export const CLICK_THRESHOLD = 6;
export const MIN_HORIZONTAL_SCROLLBAR_WIDTH = 50;
export const MIN_VERTICAL_SCROLLBAR_WIDTH = 50;

export const VERTICAL_SCROLLBAR_WIDTH = 8;
export const HORIZONTAL_SCROLLBAR_HEIGHT = 8;
export const SCROLLBAR_RADIUS = 4;
export const SCROLLBAR_PADDING = 2;

export const REGION_DRAG_INDICATOR_WIDTH = 5;
export const REGION_DRAG_INDICATOR_HOVER_WIDTH = 3;

export const MIN_FOCUSED_SHAPE_WIDTH = 100;

export const DOUBLE_CLICK_DELAY = 300; // milliseconds
export const LONG_PRESS_TIMEOUT = 500;
export const HIGHLIGHT_DELAY = 2000;

export const CANVAS_VISIBILITY_OFFSCREEN_MARGIN = 200; // pixels

// TODO Change this value according to SEL11-600 decisions
export const MAX_RANGE_LENGTH_FOR_SEQUENCE_VIEWER = 100_000;

// Entity types
export const URL_ENTITY_TYPES = {
  GENE: "gene",
  TRANSCRIPT: "transcript",
  PROTEIN: "protein",
  SEQUENCE: "sequence",
  TRANSCRIPT_LOCATION: "transcriptLocation",
  PROTEIN_LOCATION: "proteinLocation",
  NUFEATURE: "nuFeature",
  AAFEATURE: "aaFeature",
};

export const syntenyViewerDefaultTracks = [
  { name: "Sequence", type: TrackEnum.SEQUENCE, isConfigurable: false },
  { name: "Gene", type: TrackEnum.GENE },
  { name: "Protein", type: TrackEnum.PROTEIN_LOCATION },
];

export const GENOMIC_TYPE_DISPLAY_NAME: Record<GenomicFeatureTypeEnum, string> = {
  GENE: "gene",
  TRANSCRIPT: "transcript",
  TRANSCRIPT_LOCATION: "transcript",
  PROTEIN: "protein",
  PROTEIN_LOCATION: "protein",
  ORGANISM: "genome",
  CONTIG: "contig",
  REGION_FLAG: "genome flag",
  COORDINATE: "coordinate",
  NUCLEOTIDE_FEATURE: "DNA feature",
  AA_SEQUENCE_FEATURE: "protein feature",
  VCF_VARIANT: "variant",
  MARKER: "marker",
  MARKER_NUS: "marker",
};

export const SEQUENCE_TYPE_LABEL: Record<number, string> = {
  4: "mRNA",
  5: "rRNA",
  6: "tRNA",
  12: "EST",
  15: "snoRNA",
  16: "snRNA",
  17: "lncRNA",
  18: "ncRNA",
};
